export const toIsoString = (date: Date) =>
  date.toISOString().replace(/-|:|\.\d+/g, '');

export const escapeICSString = (str: string) =>
  str
    .replace(/\\/g, '\\\\')
    .replace(/,/g, '\\,')
    .replace(/;/g, '\\;')
    .replace(/\n/g, '\\n');

export const generateIcs = (
  bookingId: string,
  eventStart: string,
  eventEnd: string,
  eventTitle: string,
  eventDescription: string,
  eventAddress: string,
  timezone: string
) =>
  [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Clover Hospitality//Reservations App//EN',
    'CALSCALE:GREGORIAN',
    'BEGIN:VEVENT',
    `UID:${bookingId}@cloverhospitality.com`,
    `DTSTAMP:${new Date()}`,
    `DTSTART;TZID=${timezone}:${eventStart}`,
    `DTEND;TZID=${timezone}:${eventEnd}`,
    `SUMMARY:${escapeICSString(eventTitle)}`,
    `DESCRIPTION:${escapeICSString(eventDescription)}`,
    `LOCATION:${escapeICSString(eventAddress)}`,
    `END:VEVENT`,
    `END:VCALENDAR`
  ].join('\r\n');
